/**
 * When used on a section, ( for instance the info-bar )
 * the section will slide open on page load and slide down on button click.
 */

const animatedSection = document.getElementById( 'animated-section__button' );
if ( animatedSection ) {
	animatedSection.addEventListener( 'click', function() {
		const container = this.parentElement.parentElement;
		container.style.height = '0px';
	} );
}

window.onload = function() {
	const container = document.getElementById( 'animated-section__container' );
	if ( container ) {
		container.style.height = 'auto';
		const height = container.clientHeight + 'px'; // Get the computed height of the container.
		container.style.height = '0px';

		setTimeout( () => {
			container.style.height = height;
		}, 0 );
	}
};
